/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */
import ccTab from '@/components/common/tab/index.vue';
import spajtj from './tabPage/spajtj/index.vue';
import zxajtj from './tabPage/zxajtj/index.vue';
import swajtj from './tabPage/swajtj/index.vue';
import sgatajtj from './tabPage/sgatajtj/index.vue';
import pmfx from './tabPage/pmfx/index.vue';
import mtdMixins from '@/pages/mixins/index.js';
export default {
    name: 'szsj',
    components: {ccTab, spajtj, zxajtj, swajtj, sgatajtj, pmfx},
    mixins:[mtdMixins],
    data() {
        return {
            tabList:Object.freeze([{
                name: '审判案件',
                code: 'spajtj'
            }, {
                name: '执行案件',
                code: 'zxajtj'
            }, {
                name: '涉外案件',
                code: 'swajtj'
            }, {
                name: '涉港澳台案件',
                code: 'sgatajtj'
            }]),
            activeTab:'spajtj',
            // 查询条件
            searchData:{tjsj: ''}
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'审执数据',
                key:'szsj'
            }];
            const listItem = this.tabList.filter(item => item.code === this.activeTab)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.activeTab = this.$route.query.tab || 'spajtj';
            this.initYear();
        },
        initYear() {
            this.dealYear(3);
            this.$nextTick(() => {
                this.searchData.tjsj = this.yearList[0].code.toString();
            });
        },
        // 点击查询
        clickSearch() {
            if (this.activeTab === 'spajtj') {
                this.$refs.spajtj.init();
            } else if (this.activeTab === 'sgatajtj') {
                this.$refs.sgatajtj.init();
            } else if (this.activeTab === 'zxajtj') {
                this.$refs.zxajtj.init();
            } else if (this.activeTab === 'swajtj') {
                this.$refs.swajtj.init();
            }
        },
        // 重置
        resetSearch() {
            this.initYear();
            // 请求
            this.clickSearch();
        },
        // 点击切换tab
        changeTab(active) {
            this.activeTab = active;
        }


    }
};

